import { render } from "./ExchangeRatesLogoIcon.vue?vue&type=template&id=331fd8dc"
import script from "./ExchangeRatesLogoIcon.vue?vue&type=script&lang=js"
export * from "./ExchangeRatesLogoIcon.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/flydata-next/flydata-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__